import React from 'react';

type BadgeVariant =
  | 'pending' |'published' |'rejected' |'disputed' |'oral' |'sourced' |'firsthand' |'tier-new' |'tier-trusted' |'tier-historian' |'tier-elder' |'default';

interface BadgeProps {
  variant: BadgeVariant;
  label: string;
  className?: string;
  size?: 'sm' | 'md';
}

const variantMap: Record<BadgeVariant, string> = {
  pending: 'status-pending',
  published: 'status-published',
  rejected: 'status-rejected',
  disputed: 'status-disputed',
  oral: 'certainty-oral',
  sourced: 'certainty-sourced',
  firsthand: 'certainty-firsthand',
  'tier-new': 'tier-new',
  'tier-trusted': 'tier-trusted',
  'tier-historian': 'tier-historian',
  'tier-elder': 'tier-elder',
  default: '',
};

export default function Badge({ variant, label, className = '', size = 'sm' }: BadgeProps) {
  const sizeClass = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm';
  return (
    <span
      className={`inline-flex items-center font-medium rounded-full ${sizeClass} ${variantMap[variant]} ${className}`}
    >
      {label}
    </span>
  );
}